import { createSlice, current } from "@reduxjs/toolkit";
import * as Act from "./actions";

const initialState = {
  loading: false,
  contactForm: [],
  totalCount: 0,
};

const slice = createSlice({
  name: "contactForm",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(Act.getContactForm.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.getContactForm.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      contactForm: payload.data,
      totalCount: payload.totalcount,
    }));
    builder.addCase(Act.getContactForm.rejected, (state, action) => ({
      ...state,
      loading: false,
      contactForm: [],
      totalCount: 0,
    }));
  },
});
export default slice;
